<template>
    <!-- 数据统计时间筛选组件 -->
    <div class="page">
        <el-form :inline="true" class="form">
            <el-form-item label="选择日期" class="item-date">
                <el-date-picker v-model="datePickerModel" :editable="false" value-format="yyyy-MM-dd" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" prefix-icon="">
                </el-date-picker>
            </el-form-item>
            <div class="item-range">
                <span class="tiem-range" v-for="(item, index) in pickerOptions" :key="index" @click="selectTime(index)">
                    {{ item.label }}
                </span>
            </div>
            <el-form-item class="item-type">
                <el-button type="primary" @click="submitForm">查询</el-button>
                <el-button @click="resetForm">重置</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
export default {
  // inject: ['submitForm'],
  props: {
    datePicker: Array,
  },
  data() {
    return {
      pickerOptions: [
        {
          label: '最近三天',
          value: 0,
        },
        {
          label: '最近一周',
          value: 0,
        },
        {
          label: '最近一月',
          value: 0,
        },
      ],
      datePickerModel: [],
    };
  },

  watch: {
    datePicker: {
      handler(data) {
        this.datePickerModel = data;
      },
      immediate: true,
    },
  },

  methods: {
    // 选择时间范围
    selectTime(index) {
      this.$emit('selectTime', index);
    },

    // 重置表单
    resetForm() {
      this.$emit('resetForm');
    },
    //查询
    submitForm() {
      this.$emit('submitForm', this.datePickerModel);
    },
  },
};
</script>

<style lang="less" scoped>
@import '~@/assets/style/mixins.less';
@import '~@/assets/style/var.less';
.form {
  height: 40px;
  padding: 20px;
  background: @bg-white;
}
.item-date {
  /deep/.el-form-item__content {
    width: 280px;
  }
  /deep/.el-date-editor--daterange {
    width: 280px;
  }
}
.item-range {
  display: inline-block;
  margin-top: 12px;
}
.tiem-range {
  display: inline-block;
  color: @primary-blue;
  padding: 0 19px;
  border-right: 1px solid @primary-blue;
  cursor: pointer;
}
.tiem-range:last-child {
  border: none;
}
</style>
